<template>
  <div>
    <div class="opo02">
      <span class="opo03" @click="back()">刀具柜列表 ></span>
      <span class="opo04"> 运营人员</span>
    </div>
    <div class="opo01">
      <div class="djt30">
        <div class="djt31">
          <input v-model="searchs" type="text" placeholder="输入名称进行搜索" placeholder-class="djt32" class="djt33">
          <img @click="seas" src="@/assets/images/sea01.png" alt="" class="djt34">
        </div>
      </div>
<!--      <div class="djt02" @click="addSB">-->
<!--        <img src="@/assets/images/add01.png" class="djt03" alt="">-->
<!--        <p class="djt04">添加设备</p>-->
<!--      </div>-->

    </div>
    <div class="djt05">
      <div class="djt06">
        <div class="djt26">工业云账号</div>
        <div class="djt26">卡号</div>
        <div class="djt26">姓名</div>
        <div class="djt26">操作</div>
      </div>
      <el-skeleton animated :loading="loading" :count="6">
        <template slot="template">
          <el-skeleton-item variant="p" style="width: 100%;height: 80px;" />
        </template>
        <template>
          <div class="djt09" v-for="(item,index) in data.dataList" :key="'lis'+index">
            <div class="djt27" :title="item.name">{{item.mobile}}</div>
            <div class="djt27" :title="item.code">{{item.cardno}}</div>
            <div class="djt27" :title="item.name">{{item.name}}</div>
            <div class="djt28">
              <img src="@/assets/images/0001.png" class="djy16" @click="qxsz(item)" alt="" v-if="item.isadmin == 0">
              <img src="@/assets/images/001.png" class="djy16" @click="qxsz(item)" alt="" v-else>
            </div>
          </div>
        </template>
      </el-skeleton>
      <div class="djt09" style="border-bottom: none;margin-top: 5px;">
        <el-pagination
          @current-change="toPage"
          background
          :page-size="8"
          :page-count="data.totalPage"
          layout="prev, pager, next"
          class="djt29"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  var me;
  var user;
  import httpUser from "@/api/user";
  import util from '@/util/util';
  export default {
    name: "djgyy",
    data(){
      return{
        isModel:false,
        loading:true,
        pageSize:7,
        page:1,
        data:[],
        sbid:'',
        searchs:'',
      }
    },
    created() {
      me = this;
      user = JSON.parse(sessionStorage.getItem('user'));
    },
    mounted() {
      me.sbid = me.$route.query.id;
      let data = {
        companyid:user.companyId,
        pageSize:me.pageSize,
        page:1,
        deviceid:me.sbid,
      }
      httpUser.getdeviceoperlist(data).then(res => {
        console.log(res);
        me.data = res.data;
        me.loading = false;
      })
    },
    methods:{
      qxsz(item){//权限设置
        me.$Loading.start();
        let data = {
          deviceid:me.sbid,
          userid:item.id,
          cuserid:user.userId,
        }
        if (item.isadmin == 0) {
          data['value'] = 1;
        } else {
          data['value'] = 0;
        }
        httpUser.setdeviceoper(data).then(res => {
          switch (res.code) {
            case "0000":
              let data = {
                companyid:user.companyId,
                pageSize:me.pageSize,
                page:me.page,
                deviceid:me.sbid,
                keyword:me.searchs,
              }
              httpUser.getdeviceoperlist(data).then(res => {
                console.log(res);
                me.data = res.data;
              })
              me.$Loading.finish();
              me.$message.success('修改权限成功');
              break;
            case "1111":
              me.$Loading.error();
              me.$message.error('请稍后再试');
              break;
          }
        })
      },
      seas(){
        var flag = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]")
        if(flag.test(me.searchs)){
          me.$message.error('请勿输入特殊字符');
          return false;
        }
        me.$Loading.start();
        let data = {
          companyid:user.companyId,
          pageSize:me.pageSize,
          page:1,
          deviceid:me.sbid,
          keyword:me.searchs,
        }
        httpUser.getdeviceoperlist(data).then(res => {
          console.log(res);
          me.$Loading.finish();
          me.data = res.data;
        })
      },
      toPage(e){//分页
        me.loading = true;
        let data = {
          companyid:user.companyId,
          pageSize:me.pageSize,
          page:e,
          deviceid:me.sbid,
          keyword:me.searchs,
        }
        me.page = e;
        httpUser.getdeviceoperlist(data).then(res => {
          me.data = res.data;
          me.loading = false;
        })
      },
      back(){//返回列表
        me.$router.push({path:'/djglist'});
      }
    }
  }
</script>

<style scoped>
@import "djgyy.css";
</style>